import { ref, computed } from 'vue'
import { user } from '@/store/user'

const useCabinets = {
  getCabinets : () => {
    const { cabinets } = user.value

    if( cabinets === undefined ) return null

    const getCabinetsQuery = computed(() => {
      return cabinets
    })

    return getCabinetsQuery.value
  },
  getCurrent : () => {
    const { cabinets } = user.value

    if( cabinets == undefined ) return null

    const getCurrentQuery = computed(() => cabinets.find(item=>item.isActive==true))
    return getCurrentQuery.value
  },
  setCurrent(cabinet) {
    // RemoveLastCurrent
    const { cabinets } = user.value

    const currentCabinet = cabinets.find(item=>item.isActive==true)
    if (currentCabinet) currentCabinet.isActive = false

    // UpdateCurrent
    const newCurrentCabinet = cabinets.find(item=>item.name === cabinet)
    newCurrentCabinet.isActive = true
  }
}

export { useCabinets }
